import React from 'react';
import Box from '@material-ui/core/Box';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@mui/material/Alert';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { AlertTitle } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { colors } from '../../theme/color-palette';
import {
	YOU_HAVE_UNREAD_NOTIFICATIONS,
	VIEW_NOTIFICATION,
} from '../../constants/constant';

function Alerts(props) {
	const [open, setOpen] = React.useState(true);

	return (
		<Collapse in={open}>
			<Alert
				elevation={6}
				variant="filled"
				{...props}
				action={
					<IconButton
						aria-label="close"
						color="inherit"
						size="small"
						onClick={() => {
							setOpen(false);
						}}>
						<CloseIcon fontSize="inherit" />
					</IconButton>
				}
			/>
		</Collapse>
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		'& .MuiAlert-filledInfo': {
			color: '#fff !important',
			backgroundColor: '#3c228a !important',
		},
		'& > * + *': {
			marginTop: theme.spacing(3),
			'& .MuiAlert-message': {
				padding: '0 !important',
			},
		},
	},
	snackbar: {
		marginTop: theme.spacing(3.4),
		right: 64,
		top: 42,
		borderLeft: `4px solid ${colors.PURPLE}`,
		borderRadius: 8,
		zIndex: theme.zIndex.tooltip + 1,
		background: '#fff',
		'& > MuiPaper-root': {
			width: 600,
		},
	},
}));

const ToastMessages = ({ viewDetailsHandler, open = false, toastHandler }) => {
	const classes = useStyles();

	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		toastHandler(false);
	};

	return (
		<div className={classes.root}>
			<Snackbar
				id="toastMessage"
				open={open}
				onClose={handleClose}
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				className={classes?.snackbar}>
				<Alerts severity="error" color={'info'}>
					<AlertTitle>{YOU_HAVE_UNREAD_NOTIFICATIONS}</AlertTitle>
					<Box
						component="span"
						onClick={viewDetailsHandler}
						sx={{
							p: 0,
							m: 0,
							width: 400,
							textDecoration: 'underline',
							fontSize: '14px',
							cursor: 'pointer',
						}}>
						{VIEW_NOTIFICATION}
					</Box>
				</Alerts>
			</Snackbar>
		</div>
	);
};

ToastMessages.propTypes = {
	viewDetailsHandler: PropTypes.func,
	open: PropTypes.bool,
	toastHandler: PropTypes.func,
};

export default ToastMessages;
